import { ButtonProps } from "./button.types";

export const Button = ({ children, ...props }: ButtonProps) => {
  return (
    <button
      {...props}
      className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:bg-gray-300"
    >
      {children}
    </button>
  );
};
